import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ChangePassword from "@/pages/ChangePassword";
import Scenarios from "@/pages/Scenarios";
import Journeys from "@/pages/Journeys";
import Session from "@/pages/Session";
import PostSession from "@/pages/PostSession";
import History from "@/pages/History";
import AdminCompanies from "@/pages/admin/AdminCompanies";
import AdminCompanyDetail from "@/pages/admin/AdminCompanyDetail";
import AdminBatchDetail from "@/pages/admin/AdminBatchDetail";
import ParticipantDetail from "@/pages/admin/ParticipantDetail";
import AdminFacilitators from "@/pages/admin/AdminFacilitators";
import AdminUsageReport from "@/pages/admin/AdminUsageReport";
import QRCodePage from "@/pages/QRCodePage";
import RoleGuard from "@/components/RoleGuard";

import AnalyticsLayout from "@/pages/analytics/AnalyticsLayout";
import Overview from "@/pages/analytics/Overview";
import BatchAnalytics from "@/pages/analytics/BatchAnalytics";
import CompetencyAnalytics from "@/pages/analytics/CompetencyAnalytics";
import ParticipantReports from "@/pages/analytics/ParticipantReports";
import ScenarioAnalytics from "@/pages/analytics/ScenarioAnalytics";
import FacilitatorDebrief from "@/pages/analytics/FacilitatorDebrief";
import BenchmarkReports from "@/pages/analytics/BenchmarkReports";
import ExecutiveDashboard from "@/pages/analytics/ExecutiveDashboard";

function App() {
  return (
    <div className="app-shell">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route
              path="/scenarios"
              element={
                <ProtectedRoute>
                  <Scenarios />
                </ProtectedRoute>
              }
            />
            <Route
              path="/journeys"
              element={
                <ProtectedRoute>
                  <Journeys />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session/:id"
              element={
                <ProtectedRoute>
                  <Session />
                </ProtectedRoute>
              }
            />
            <Route
              path="/session/:id/review"
              element={
                <ProtectedRoute>
                  <PostSession />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <History />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/companies"
              element={
                <RoleGuard allow={["admin", "facilitator"]}>
                  <AdminCompanies />
                </RoleGuard>
              }
            />
            <Route
              path="/admin/companies/:id"
              element={
                <RoleGuard allow={["admin", "facilitator"]}>
                  <AdminCompanyDetail />
                </RoleGuard>
              }
            />
            <Route
              path="/admin/batches/:id"
              element={
                <RoleGuard allow={["admin", "facilitator"]}>
                  <AdminBatchDetail />
                </RoleGuard>
              }
            />
            <Route
              path="/admin/participants/:id"
              element={
                <RoleGuard allow={["admin", "facilitator"]}>
                  <ParticipantDetail />
                </RoleGuard>
              }
            />
            <Route
              path="/admin/facilitators"
              element={
                <RoleGuard allow={["admin"]}>
                  <AdminFacilitators />
                </RoleGuard>
              }
            />
            <Route path="/qr-code" element={<QRCodePage />} />
            <Route
              path="/admin/usage-report"
              element={
                <RoleGuard allow={["admin"]}>
                  <AdminUsageReport />
                </RoleGuard>
              }
            />
            <Route
              path="/analytics"
              element={
                <RoleGuard allow={["admin", "facilitator", "executive"]}>
                  <AnalyticsLayout />
                </RoleGuard>
              }
            >
              <Route index element={<Overview />} />
              <Route path="batches" element={<BatchAnalytics />} />
              <Route path="competencies" element={<CompetencyAnalytics />} />
              <Route path="participants" element={<ParticipantReports />} />
              <Route path="scenarios" element={<ScenarioAnalytics />} />
              <Route path="debrief" element={<FacilitatorDebrief />} />
              <Route path="benchmark" element={<BenchmarkReports />} />
              <Route path="executive" element={<ExecutiveDashboard />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
